import React, { useEffect } from "react";
import AddResource from "../../components/header/AddResource";
import { useNotification } from "../../components/notification/NotificationContainer";
import { useForm } from "react-hook-form";
import ReformulationInputTable from "../../components/form/ReformulationInputTable";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { editReformulations } from "../../features/donorsSlice";
import { closeModal } from "../../features/modalSLice";

const EditReformTemplate = ({ id, reformulations }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.donors.load.editReformulations);
  const addNotification = useNotification();
  const {
    handleSubmit,
    register,
    setValue,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(editReformulations({ id, data }));
      if (editReformulations.fulfilled.match(res)) {
        addNotification("Reformulations edited successfully!", "success");
        dispatch(closeModal());
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    reset({ reformulations: reformulations || [] });
  }, [reformulations.reformulations]);

  return (
    <div className="min-w-[25rem] sm:min-w-[35rem] lg:min-w-[50rem] xl:min-w-[70rem] w-full h-[90vh]">
      <AddResource title="Update Reformulation Template" />
      <form
        autoComplete="off"
        autoCorrect="off"
        onSubmit={handleSubmit(onSubmit)}
        className="h-full flex flex-col pb-16"
      >
        <ReformulationInputTable
          register={register}
          setValue={setValue}
          errors={errors.reformulations}
          name="reformulations"
          label="Reformulations"
          control={control}
          donor_id={id}
          watch={watch}
        />

        <ResourseButtons submitText="Save" loading={loading} />
      </form>
    </div>
  );
};

export default EditReformTemplate;
